/* eslint-disable camelcase */
/* eslint-disable no-return-assign */
/* eslint-disable max-len */
/* eslint-disable quotes */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import Tooltip from '../../../common/Tooltip';

export function AdditionalInfo({
    updateField,
    freelancers_information,
    admin_information,
    nature_of_business,
    required_qualifications,
    safety_risks,
    available_facilities,
    expenses_payable,
    title,
    freelancersInformationRef,
    natureRef,
    qualificationsRef,
    risksRef,
    facilitiesRef,
    payableRef,
    titleRef,
    freelancersInformationLabelRef,
    natureLabelRef,
    qualificationsLabelRef,
    risksLabelRef,
    facilitiesLabelRef,
    payableLabelRef,
    titleLabelRef,
    default_nature_of_business,
    default_required_qualifications,
    default_safety_risks,
    default_available_facilities,
    default_expenses_payable,
    isClient = false,
    qualificationsChanged = undefined,
    risksChanged = undefined,
    facilitiesChanged = undefined,
    payableChanged = undefined,
    setQualificationsChanged = undefined,
    setRisksChanged = undefined,
    setFacilitiesChanged = undefined,
    setPayableChanged = undefined,
}) {
    useEffect(() => {
        if (default_nature_of_business) updateField('nature_of_business', default_nature_of_business);
        if (default_required_qualifications) updateField('required_qualifications', default_required_qualifications);
        if (default_safety_risks) updateField('safety_risks', default_safety_risks);
        if (default_available_facilities) updateField('available_facilities', default_available_facilities);
        if (default_expenses_payable) updateField('expenses_payable', default_expenses_payable);
    }, []);

    useEffect(() => {
        if (!isClient && default_nature_of_business) {
            updateField('nature_of_business', default_nature_of_business);
        }
    }, [default_nature_of_business]);

    useEffect(() => {
        if ((!isClient || qualificationsChanged === false) && default_required_qualifications) {
            updateField('required_qualifications', default_required_qualifications);
        }
    }, [default_required_qualifications]);

    useEffect(() => {
        if ((!isClient || risksChanged === false) && default_safety_risks) {
            updateField('safety_risks', default_safety_risks);
        }
    }, [default_safety_risks]);

    useEffect(() => {
        if ((!isClient || facilitiesChanged === false) && default_available_facilities) {
            updateField('available_facilities', default_available_facilities);
        }
    }, [default_available_facilities]);

    useEffect(() => {
        if ((!isClient || payableChanged === false) && default_expenses_payable) {
            updateField('expenses_payable', default_expenses_payable);
        }
    }, [default_expenses_payable]);

    const handleOnChange = e => {
        updateField(e.target.name, e.target.value);

        if (isClient) {
            if (e.target.name === 'required_qualifications' && qualificationsChanged) {
                setQualificationsChanged(true);
            } else if (e.target.name === 'safety_risks' && risksChanged) {
                setRisksChanged(true);
            } else if (e.target.name === 'available_facilities' && facilitiesChanged) {
                setFacilitiesChanged(true);
            } else if (e.target.name === 'expenses_payable' && payableChanged) {
                setPayableChanged(true);
            }
        }
    };

    return (
        <div className="AdditionalInfo__container">
            <div className="AdditionalInfo__details">
                <span className="mandatory">
                    <label
                        ref={titleLabelRef}
                        htmlFor="title"
                        autoComplete="nope"
                    >
                        Job Title
                    </label>
                </span>
                <textarea
                    ref={titleRef}
                    id="title"
                    name="title"
                    autoComplete="nope"
                    value={title || ''}
                    onChange={handleOnChange}
                />
            </div>
            {isClient ? (
                <>
                    <div className="AdditionalInfo__details">
                        <span>
                            <label htmlFor="internal" autoComplete="nope">
                                Information for Berry{` `}
                            </label>
                            <Tooltip tooltip="Please write any information you’d like to specifically share with Berry Recruitment such as worker preferences.">
                                <i className="icon icon-infomation-circle" />
                            </Tooltip>
                        </span>
                        <textarea
                            id="internal"
                            name="admin_information"
                            value={admin_information || ''}
                            onChange={handleOnChange}
                        />
                    </div>
                    <div className="AdditionalInfo__details">
                        <span className="mandatory">
                            <label
                                ref={freelancersInformationLabelRef}
                                htmlFor="workers"
                                autoComplete="nope"
                            >
                                Information for workers{` `}
                            </label>
                            <Tooltip tooltip="Does the worker need to bring specific uniform? Does the worker need to have obtained a particular certification? This information will be shared with interested candidates.">
                                <i className="icon icon-infomation-circle" />
                            </Tooltip>
                        </span>
                        <textarea
                            ref={freelancersInformationRef}
                            id="workers"
                            name="freelancers_information"
                            autoComplete="nope"
                            value={freelancers_information || ''}
                            onChange={handleOnChange}
                        />
                    </div>
                </>
            ) : (
                <>
                    <div className="AdditionalInfo__details">
                        <label htmlFor="workers" autoComplete="nope">
                            Extra information for workers
                        </label>
                        <textarea
                            id="workers"
                            name="freelancers_information"
                            autoComplete="nope"
                            value={freelancers_information || ''}
                            onChange={handleOnChange}
                        />
                    </div>
                    <div className="AdditionalInfo__details">
                        <label htmlFor="internal" autoComplete="nope">
                            Internal details
                        </label>
                        <textarea
                            id="internal"
                            name="admin_information"
                            value={admin_information || ''}
                            onChange={handleOnChange}
                        />
                    </div>
                </>
            )}
            <div className="AdditionalInfo__details">
                <label
                    ref={natureLabelRef}
                    htmlFor="business"
                    autoComplete="nope"
                >
                    <span className="mandatory">
                        Nature of {isClient ? 'your' : 'the Hirer’s'} business
                    </span>
                </label>
                <textarea
                    ref={natureRef}
                    id="business"
                    name="nature_of_business"
                    value={nature_of_business || ''}
                    onChange={handleOnChange}
                />
            </div>
            <div className="AdditionalInfo__details">
                <span className="mandatory">
                    <label
                        ref={qualificationsLabelRef}
                        htmlFor="qualifications"
                        autoComplete="nope"
                    >
                        Experience and Training Required{` `}
                    </label>
                    <Tooltip tooltip="The experience, training, qualifications and any authorisation necessary or required by law or a professional body">
                        <i className="icon icon-infomation-circle" />
                    </Tooltip>
                </span>
                <textarea
                    ref={qualificationsRef}
                    id="qualifications"
                    name="required_qualifications"
                    value={required_qualifications || ''}
                    onChange={handleOnChange}
                />
            </div>
            <div className="AdditionalInfo__details">
                <span className="mandatory">
                    <label
                        ref={risksLabelRef}
                        htmlFor="risks"
                        autoComplete="nope"
                    >
                        Health and safety risks{` `}
                    </label>
                    <Tooltip tooltip="Any known health and safety risks and the steps the hirer has taken to reduce the risks">
                        <i className="icon icon-infomation-circle" />
                    </Tooltip>
                </span>
                <textarea
                    ref={risksRef}
                    id="risks"
                    name="safety_risks"
                    value={safety_risks || ''}
                    onChange={handleOnChange}
                />
            </div>
            <div className="AdditionalInfo__details">
                <span className="mandatory">
                    <label
                        ref={facilitiesLabelRef}
                        htmlFor="facilities"
                        autoComplete="nope"
                    >
                        Collective facilities{` `}
                    </label>
                    <Tooltip tooltip="Hirer’s collective facilities available to the Agency Worker (e.g. canteen)">
                        <i className="icon icon-infomation-circle" />
                    </Tooltip>
                </span>
                <textarea
                    ref={facilitiesRef}
                    id="facilities"
                    name="available_facilities"
                    value={available_facilities || ''}
                    onChange={handleOnChange}
                />
            </div>
            <div className="AdditionalInfo__details">
                <label
                    ref={payableLabelRef}
                    htmlFor="payable"
                    autoComplete="nope"
                >
                    <span className="mandatory">
                        Any expenses payable by, or to the worker
                    </span>
                </label>
                <textarea
                    ref={payableRef}
                    id="payable"
                    name="expenses_payable"
                    value={expenses_payable || ''}
                    onChange={handleOnChange}
                />
            </div>
        </div>
    );
}
